<template>
  <div style="padding: 20px 8%">
    <div class="text-blue font-weight-bold">请选择策略模式</div>
    <div class="display-flex">
      <div  class="flex-50">
        <div class="modeBox pointer"
             :class="selectMode === 'simple' ? 'frosted-glass' : ''"
              @touchstart="changeMode('simple')"
             @click="changeMode('simple')">
          <div class="font-weight-bold text-lightBlue text-center">简单策略</div>
          <div class="text-center margin-top-20">可通过场景和执行条件来实现</div>
          <el-checkbox
            class="checkbox"
            :value="selectMode"
            true-label="simple"
            false-label="complex"
          >
          </el-checkbox>
        </div>
      </div>
      <div class="flex-50">
        <div class="modeBox pointer"
             :class="selectMode === 'complex' ? 'frosted-glass' : ''"
             @touchstart="changeMode('complex')"
             @click="changeMode('complex')">
          <div class="font-weight-bold text-lightBlue text-center">复杂策略</div>
          <div class="text-center margin-top-20">通过应用工作流引擎,提前配置好流程节点和流程条件,并为流程设定触发的设备.</div>
          <el-checkbox
            class="checkbox"
            :value="selectMode"
            true-label="complex"
            false-label="simple"
          >
          </el-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StrategyModeSelect",
  props: ['mode'],
  data() {
    return {
      selectMode: '',
    }
  },
  mounted() {
    this.selectMode = this.mode
  },
  watch:{
    mode(){
      this.selectMode = this.mode
    },
    selectMode(){
      this.$emit('receiveMode',this.selectMode)
    }
  },
  methods:{
    changeMode(selectMode){
      this.selectMode = selectMode
    }
  }
}
</script>

<style scoped>
.modeBox {
  width: 90%;
  height: 180px;
  margin: 50px auto;
  background-color: rgba(41, 155, 255, .1);
  border-radius: 8px;
  padding: 30px;
  position: relative;
}

.frosted-glass {
  border: 1px solid rgba(41, 155, 255, 1);
  box-shadow: -0.1px 0 30px 0 rgba(41, 155, 255, .2),
  -0.5px 0 30px 0 rgba(41, 155, 255, .1),
  -1px 0 30px 0 rgba(41, 155, 255, 0.05),
  -1.5px 0 30px 0 rgba(41, 155, 255, 0.01);
  /*transition: 0.5s ease;*/
}

.checkbox {
  position: absolute;
  bottom: 5px;
  right: 15px;
}
</style>
